import { render, staticRenderFns } from "./StatusPeriod.vue?vue&type=template&id=2f254e65"
import script from "./StatusPeriod.vue?vue&type=script&lang=js"
export * from "./StatusPeriod.vue?vue&type=script&lang=js"
import style0 from "./StatusPeriod.vue?vue&type=style&index=0&id=2f254e65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports